import { EnhancedActivityForm } from '@/components/activity/EnhancedActivityForm';

export default function CreateActivity() {
  return (
    <div className="space-y-6">
      <EnhancedActivityForm />
    </div>
  );
}
